var moduleMap = {
	"./ProcessManager": () => {
		return __webpack_require__.e(4816).then(() => (() => ((__webpack_require__(84816)))));
	},
	"./ppPrivateFetcher": () => {
		return Promise.all([__webpack_require__.e(3019), __webpack_require__.e(6548), __webpack_require__.e(382), __webpack_require__.e(8960), __webpack_require__.e(2970), __webpack_require__.e(1858), __webpack_require__.e(3969), __webpack_require__.e(6827)]).then(() => (() => ((__webpack_require__(42513)))));
	},
	"./appStateManager": () => {
		return Promise.all([__webpack_require__.e(3019), __webpack_require__.e(6548), __webpack_require__.e(382), __webpack_require__.e(8960), __webpack_require__.e(2970), __webpack_require__.e(1858), __webpack_require__.e(3969), __webpack_require__.e(71)]).then(() => (() => ((__webpack_require__(60111)))));
	},
	"./ppUserAccountService": () => {
		return Promise.all([__webpack_require__.e(3019), __webpack_require__.e(6548), __webpack_require__.e(382), __webpack_require__.e(8960), __webpack_require__.e(2970), __webpack_require__.e(1858), __webpack_require__.e(3969), __webpack_require__.e(9647)]).then(() => (() => ((__webpack_require__(46099)))));
	},
	"./ppAppEndpointsConfig": () => {
		return Promise.all([__webpack_require__.e(1858), __webpack_require__.e(9508)]).then(() => (() => ((__webpack_require__(99508)))));
	},
	"./fetchers/ppWebhook": () => {
		return Promise.all([__webpack_require__.e(3019), __webpack_require__.e(6548), __webpack_require__.e(382), __webpack_require__.e(8960), __webpack_require__.e(2970), __webpack_require__.e(1858), __webpack_require__.e(3969), __webpack_require__.e(507)]).then(() => (() => ((__webpack_require__(60354)))));
	},
	"./fetchers/ppPrivateFetcher": () => {
		return Promise.all([__webpack_require__.e(3019), __webpack_require__.e(6548), __webpack_require__.e(382), __webpack_require__.e(8960), __webpack_require__.e(2970), __webpack_require__.e(1858), __webpack_require__.e(3969), __webpack_require__.e(6827)]).then(() => (() => ((__webpack_require__(42513)))));
	},
	"./fetchers/ppCustomNotification": () => {
		return Promise.all([__webpack_require__.e(3019), __webpack_require__.e(6548), __webpack_require__.e(382), __webpack_require__.e(8960), __webpack_require__.e(5042), __webpack_require__.e(2970), __webpack_require__.e(1858), __webpack_require__.e(3969), __webpack_require__.e(1648), __webpack_require__.e(5644)]).then(() => (() => ((__webpack_require__(19299)))));
	},
	"./fetchers/ppTrackingWidgetFetcher": () => {
		return Promise.all([__webpack_require__.e(3019), __webpack_require__.e(6548), __webpack_require__.e(382), __webpack_require__.e(8960), __webpack_require__.e(2970), __webpack_require__.e(1858), __webpack_require__.e(3969), __webpack_require__.e(7197)]).then(() => (() => ((__webpack_require__(3212)))));
	},
	"./constants/productExperience.constant": () => {
		return __webpack_require__.e(27).then(() => (() => ((__webpack_require__(10027)))));
	}
};
var get = (module, getScope) => {
	__webpack_require__.R = getScope;
	getScope = (
		__webpack_require__.o(moduleMap, module)
			? moduleMap[module]()
			: Promise.resolve().then(() => {
				throw new Error('Module "' + module + '" does not exist in container.');
			})
	);
	__webpack_require__.R = undefined;
	return getScope;
};
var init = (shareScope, initScope) => {
	if (!__webpack_require__.S) return;
	var name = "default"
	var oldScope = __webpack_require__.S[name];
	if(oldScope && oldScope !== shareScope) throw new Error("Container initialization failed as it has already been initialized with a different share scope");
	__webpack_require__.S[name] = shareScope;
	return __webpack_require__.I(name, initScope);
};

// This exports getters to disallow modifications
__webpack_require__.d(exports, {
	get: () => (get),
	init: () => (init)
});